import Ajv, { SchemaObject } from 'ajv';

import { IManifestType } from '../interfaces';

const ajv = new Ajv({ allErrors: true });

const schema: SchemaObject = {
  title: 'Manifest Request',
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    documentType: {
      type: 'string',
    },
    wasteProfileNumbers: {
      type: 'array',
      items: { type: 'string' },
    },
    generatorName: {
      type: 'string',
    },
  },
  required: ['wasteProfileNumbers', 'generatorName'],
};

ajv.addSchema(schema, 'IManifestType');

export const validate = ajv.getSchema<IManifestType>('IManifestType');
